export default "__VITE_ASSET__Cd$L$RGm__"